// state context provider
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StateContext from './stateContext';
import axios from 'axios';

function StateProvider({children}) {
  const navigate = useNavigate();
  const [ globalAppStatus, setGlobalAppStatus ] = useState("unapplied");
  const [ notifications, setNofications ] = useState([]);
  const [ applicationStati, setApplicationStati ] = useState(["unapplied", "applied", "not interested", "too far", "position accepted", "interviewing", "not selected", "ghost", "does not exist"]);
  const [ popup, setPopup ] = useState();
  const [ globalHeader, setGlobalHeader ] = useState();

  const [ userInfo, setUserInfo ] = useState({
    email: getStorage("email"),
    jwt: getStorage("jwt"),
    fullname_initials: getStorage("fullname_initials"),
    jwt_expiration: getStorage("jwt_expiration"),
    account_type: getStorage("account_type"),
    subscription_status: getStorage("subscription_status"),
    default_resume_format: parseInt(getStorage("default_resume_format"))
  });

  function getStorage(key) {
    // check if local storage is valid
    var cred = localStorage.getItem(key)
    if (cred == undefined || cred == undefined) {
      cred = sessionStorage.getItem(key)
    }
    
    return cred
  }

  useEffect(() => {
    

    if (getStorage("keep_logged_in") != true && getStorage("keep_logged_in") != "true") {
      if (userInfo.keep_logged_in !== undefined && userInfo.keep_logged_in !== null) { localStorage.setItem("keep_logged_in", true) }
      if (userInfo.email !== undefined && userInfo.email !== null) { { userInfo.keep_logged_in ? localStorage.setItem("email", userInfo.email) : sessionStorage.setItem("email", userInfo.email) } }
      if (userInfo.jwt !== undefined && userInfo.jwt !== null) { { userInfo.keep_logged_in ? localStorage.setItem("jwt", userInfo.jwt) : sessionStorage.setItem("jwt", userInfo.jwt) } }
      if (userInfo.fullname_initials !== undefined && userInfo.fullname_initials !== null) { { userInfo.keep_logged_in ? localStorage.setItem("fullname_initials", userInfo.fullname_initials) : sessionStorage.setItem("fullname_initials", userInfo.fullname_initials) } }
      if (userInfo.jwt_expiration !== undefined && userInfo.jwt_expiration !== null) { { userInfo.keep_logged_in ? localStorage.setItem("jwt_expiration", userInfo.jwt_expiration) : sessionStorage.setItem("jwt_expiration", userInfo.jwt_expiration) } }
      if (userInfo.account_type !== undefined && userInfo.account_type !== null) { { userInfo.keep_logged_in ? localStorage.setItem("account_type", userInfo.account_type) : sessionStorage.setItem("account_type", userInfo.account_type) } }
      if (userInfo.subscription_status !== undefined && userInfo.subscription_status !== null ) { { userInfo.keep_logged_in ? localStorage.setItem("subscription_status", userInfo.subscription_status) : sessionStorage.setItem("subscription_status", userInfo.subscription_status) } }
      if (userInfo.default_resume_format !== undefined && userInfo.default_resume_format !== null ) { { userInfo.keep_logged_in ? localStorage.setItem("default_resume_format", userInfo.default_resume_format) : sessionStorage.setItem("default_resume_format", userInfo.default_resume_format) } }
    }
  }, [userInfo]);

  function validUserCreds() {
    if (userInfo.email === undefined || userInfo.email == null) { return false; }
    if (userInfo.jwt === undefined || userInfo.jwt === null) { return false; }
    if (userInfo.fullname_initials === undefined || userInfo.fullname_initials === null) { return false; }
    if (userInfo.jwt_expiration === undefined || userInfo.jwt_expiration === null) { 
      return false; 
    } else if (userInfo.jwt_expiration !== undefined && userInfo.jwt_expiration < (Date.now() / 1000)) {
      return false;
    } 

    return true;
  }

  const [count, setCount] = useState(0);

  useEffect(() => {
    updateSession();

    // set session checking on interval
    const intervalId = setInterval(updateSession, 60000);

    // 2. Clean up the interval
    return () => {
      clearInterval(intervalId);
    };
  }, [userInfo]); // Empty dependency array ensures this only runs once on mount

  function updateSession() {
    // only update session if the tab is open/user is using site
    if (document.visibilityState === "visible") {
      var data = {"page": window.location.pathname}
      if (validUserCreds() == true) {
        data = {
          ...data,
          "email": userInfo.email,
          "jwt": userInfo.jwt
        }
      }

      axios.defaults.xsrfCookieName = 'csrftoken';
      axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
      axios.defaults.withCredentials = true;

      axios.post(
        '/api/account/session',
        data
      ).then((response) => {
        if (response.data.success != true || response.data.results < 0) {
          if (validUserCreds() == true) {
            // log user out
            localStorage.clear();
            setUserInfo({});
          }
        }
      })
    }
  }

  var curPathname = window.location.pathname.toLowerCase();
  if (curPathname != "" && curPathname != "/" && !curPathname.startsWith("/login") && 
      !curPathname.startsWith("/home") && !curPathname.startsWith("/signup") && 
      !curPathname.startsWith("/about") && !curPathname.startsWith("/forgotpassword") && 
      !curPathname.startsWith("/company") &&  validUserCreds() == false) {
    // delete session data
    localStorage.clear();
    sessionStorage.clear();

    navigate("/login")
  }

  function createNotification(newNotification) {
    setNofications(
      [ ...notifications, newNotification ]
    )

    setTimeout(shiftNotifications, 6000)
  }

  function deleteNotification(notiIndex) {
    setNofications(notifications.filter((_, index) => index != notiIndex))
  }

  function shiftNotifications() {
    var newNotifications = notifications
    newNotifications.shift()
    setNofications(newNotifications)
  }

  const appStatusControls = {
    globalAppStatus,
    setGlobalAppStatus,

    globalHeader,
    setGlobalHeader,

    notifications,
    createNotification,
    deleteNotification,
    applicationStati,
    userInfo, 
    setUserInfo,
    validUserCreds,
    
    popup,
    setPopup
  }
  
  async function login(event) {
    // prevent default
    event.preventDefault();

    // get form data
    const formData = new FormData(event.target);
    const dataObject = Object.fromEntries(formData.entries());

    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/account/login',
      dataObject
    ).then((response) => {
      if (response.data.success == true && response.data.results > 0) {

        // set new user info
        setUserInfo({
          "email": dataObject.email,
          "jwt": response.data.result.jwt,
          "fullname_initials": response.data.result.fullname_initials,
          "account_type": response.data.result.account_type,
          "jwt_expiration": response.data.result.jwt_expiration
        });

        // redirect user to home page
        window.location.href = "/home"
      } else {
        // unset user info
        setUserInfo({});

        // notify failure
        createNotification({
            "status": "error",
            "msg": "Login Failed",
          })
      }
    })
  }

  return (
    <StateContext.Provider value={appStatusControls}>
      {children}
    </StateContext.Provider>
  )
}

export default StateProvider